import React from 'react';
import { listboxRef, scrollContainerRef } from '../components/FilterDropdown';

export const useScrollRestore = (scrollPositionToRestore) => {
  React.useEffect(() => {
    const scrollEl = scrollContainerRef.current || listboxRef.current;
    if (scrollPositionToRestore?.current !== null && scrollEl) {
      scrollEl.scrollTop = scrollPositionToRestore.current;
      scrollPositionToRestore.current = null;
    }
  });
};
